import { render, staticRenderFns } from "./CollectorChannelConfig.vue?vue&type=template&id=6843d0aa&"
import script from "./CollectorChannelConfig.vue?vue&type=script&lang=js&"
export * from "./CollectorChannelConfig.vue?vue&type=script&lang=js&"
import style0 from "./CollectorChannelConfig.vue?vue&type=style&index=0&id=6843d0aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports